module.exports = __webpack_public_path__ + "img/icon_ai2.b2ae1a61.png";